var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 393,
    viewBox: "0 0 475 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M433.728 109.733L288.723 284.513L103.658 203.733L204.387 74.365L433.728 109.733Z",
    fill: "#8EEA36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8314 140.844L235.773 211.963L70.5457 360.898L-66.1267 257.241L-23.8314 140.844Z",
    fill: "#FCD300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.127 215.223L166.986 340.762L78.1716 234.154L132.508 65.5944L250.127 215.223Z",
    fill: "#06BF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow2);
export default __webpack_public_path__ + "static/media/Row2.e60122dfb2508d32085ce81726d1daf7.svg";
export { ForwardRef as ReactComponent };